import { Laptop, Moon, Sun } from 'lucide-react';
import { useTheme } from '@/context/ThemeContext';

const ORDER = ['light', 'dark', 'system'];
const META = {
  light: { label: 'Tema terang', icon: Sun },
  dark: { label: 'Tema gelap', icon: Moon },
  system: { label: 'Ikuti tema perangkat', icon: Laptop },
};

export default function ThemeToggle() {
  const { mode, setMode } = useTheme();
  const Icon = META[mode].icon;
  const next = ORDER[(ORDER.indexOf(mode) + 1) % ORDER.length];
  return <button type="button" onClick={() => setMode(next)} title={`${META[mode].label} · klik untuk ${META[next].label.toLowerCase()}`} aria-label={`${META[mode].label}. Ubah ke ${META[next].label.toLowerCase()}`} className="glass-control flex h-10 w-10 items-center justify-center rounded-xl text-[var(--fpccs-text-muted)] transition hover:text-[var(--fpccs-primary)]"><Icon className="h-4 w-4" /></button>;
}
